import axios from 'axios';
import store from '../stores/store';

const baseDomain = process.env.VUE_APP_BACKEND_SERVER;
const baseURL = `${baseDomain}/api/`;

const instance = axios.create({
  baseURL,
  headers: {},
});
instance.defaults.timeout = 20000;

// UPDATE HEADERS ON EVERY REQUEST
instance.interceptors.request.use((config) => {
  // eslint-disable-next-line no-param-reassign
  config.headers['Accept-Language'] = `${store.state.main.lang}`;
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = `Bearer ${store.state.main.token}`;
  return config;
});

function showSpinner(url, method) {
  const fromUser = url.includes('/user') && method === 'get';
  const fromLogin = url.includes('/login') || url.includes('/password') || url.includes('/register') || url.includes('/auth');
  const fromPayment = url.includes('/payment') && method === 'post';
  const fromOthers = url.includes('discount_code') || url.includes('claim') || url.includes('/review/main') || url.includes('/shipping');
  const fromTransfers = url.includes('/transfer/info');
  const fromActivities = url.includes('/activities') || url.includes('/activity-for-booking');
  const fromLockerAccessCodes = url.includes('/lockers/bookings');

  return (!fromUser && !fromLogin && !fromPayment && !fromOthers && !fromTransfers && !fromActivities && !fromLockerAccessCodes);
}

function increaseLoading() {
  let loadingValue = store.state.general.isLoading;

  loadingValue++;
  store.dispatch('setLoading', loadingValue);
}

function decreaseLoading() {
  let loadingValue = store.state.general.isLoading;

  if (loadingValue > 0) {
    loadingValue--;
    store.dispatch('setLoading', loadingValue);
  }
}

// Intercepts the request to show the Spinner
instance.interceptors.request.use((request) => {
  const { url } = request;
  const { method } = request;

  if (showSpinner(url, method)) {
    increaseLoading();
  }
  return request;
}, (error) => {
  const { url } = error.request.config;
  const { method } = error.request.config;

  if (showSpinner(url, method)) {
    decreaseLoading();
  }
  return Promise.reject(error);
});

// Intercepts the response to hide the Spinner
instance.interceptors.response.use((response) => {
  const { url } = response.config;
  const { method } = response.config;

  if (showSpinner(url, method)) {
    decreaseLoading();
  }
  return response;
}, (error) => {
  if (error.response) {
    const { url } = error.response.config;
    const { method } = error.response.config;

    if (showSpinner(url, method)) {
      decreaseLoading();
    }
  } else {
    decreaseLoading();
  }
  return Promise.reject(error);
});

export default instance;
